import React from 'react';

import { useTranslation } from 'react-i18next';

import scss from './ErrorList.module.scss';

function ErrorElement({ errorCode, fileName }) {
  const { t } = useTranslation('activ8');

  const mappedLabels = {
    [ERROR_CODES.INVALID_FILE_FORMAT]: t('invalidFileFormat'),
  };

  return (
    <span className={scss.errorElement}>
      {mappedLabels[errorCode] ?? t('invalidFile')}: {fileName}
    </span>
  );
}

export default ErrorElement;

const ERROR_CODES = {
  INVALID_FILE_FORMAT: 'file-invalid-type',
};
